const initialState = { byFlowId: {} };

export default function singleSegmentSelectionReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_SINGLE_SEGMENT_SELECTION_STATUS":
            return {
                ...state,
                byFlowId: {
                    ...state.byFlowId,
                    [action.payload.flowId]: action.payload.violatingFlowItemIds,
                },
            };
        case "UNSET_SINGLE_SEGMENT_SELECTION_STATUS":
            return {
                ...state,
                byFlowId: {
                    ...state.byFlowId,
                    [action.payload.flowId]: (state.byFlowId[action.payload.flowId] || []).filter(
                        id => !action.payload.violatingFlowItemIds.includes(id)
                    ),
                },
            };
        default:
            return state;
    }
}
